import React from "react"
import { View } from "./primitives"
import { flattenStyle } from "./style"
import { filterDomProps } from "./dom-props"

type Point = { x: number; y: number }

export default function LinearGradient({
  colors = ["#000", "#fff"],
  start = { x: 0, y: 0 },
  end = { x: 1, y: 1 },
  style,
  children,
  ...props
}: {
  colors?: string[]
  start?: Point
  end?: Point
  style?: unknown
  children?: React.ReactNode
}) {
  const angle = Math.atan2(end.y - start.y, end.x - start.x) * (180 / Math.PI) + 90
  const gradient = `linear-gradient(${angle}deg, ${colors.join(", ")})`
  return (
    <View style={{ ...flattenStyle(style), backgroundImage: gradient }} {...filterDomProps(props)}>
      {children}
    </View>
  )
}
